import { appendPath } from '@truqc/content-path';
import moment from 'moment';
import store from '../reducers/storeRegistration';
import reportActionCreators from '../actions/reportActionCreators';
import issueActionCreators from '../actions/issueActionCreators';
import jobActionCreators from '../actions/jobActionCreators';
import formActionCreators from '../actions/formActionCreators';
import formModalActionCreators from '../actions/formModalActionCreators';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
import { getUser } from '../utils/paths';
import { uuid } from '../../behaviors/src/lib/common';
import { convertToAbsolutePath } from '../components/editor/utils';
const actionCreators = {
  reportActionCreators,
  issueActionCreators,
  jobActionCreators,
  formActionCreators,
  formModalActionCreators
};
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const result = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  const entityActions = actionCreators["".concat(entityName, "ActionCreators")];
  const targetContentPath = await evaluateSource(source.targetContentPath, content, parentContentPath, transientContext, nativeFunctions);
  let absoluteParentContentPath = parentContentPath;
  if (!parentContentPath.startsWith('/')) {
    absoluteParentContentPath = "/".concat(parentContentPath);
  }
  const targetPath = appendPath(absoluteParentContentPath, targetContentPath);
  const state = store.getState();
  const id = state[entityName].active.id;
  await store.dispatch(entityActions.change(id, "content".concat(targetPath), result));
  const logContentPath = await evaluateSource(source.logContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof logContentPath === 'string') {
    const _getUser = getUser(),
      firstName = _getUser.firstName,
      lastName = _getUser.lastName;
    const breadcrumbs = source.breadcrumbs;
    const logPath = convertToAbsolutePath(logContentPath, targetPath);
    const fullLogPath = appendPath(logPath, uuid());
    // Generate the log value
    const logPatch = {
      _created: moment().toISOString(),
      user: "".concat(firstName, " ").concat(lastName),
      // usually `value` and `displayValue`.
      value: result,
      contentPath: parentContentPath,
      breadcrumbs
    };
    const contentLogPath = "content".concat(fullLogPath);
    // Dispatch the log event.
    await store.dispatch(entityActions.change(id, contentLogPath, logPatch));
  }
};
export default {
  evaluate
};